import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import AppWrapper from "./App";
// import reportWebVitals from "./reportWebVitals";
// import registerServiceWorker from "./registerServiceWorker";
import "./locale";

import { store } from "./store";
import "./styles/index.scss";
import { getCompanySettings } from "./services";
import { setSettings } from "./store/slice/settings";
import { i18n } from "@euroland/libs";
import { convertFormatNumber, loadConfiguredCustomStylesheet, loadVariableStylesByTemplate } from "./utils";
import { waitForDocumentReady, isFunction, stringifyError } from "@euroland/libs";
import { loadSettingEUCalendar } from "./utils";
import { FORMAT_NUMBER, POSITIVE_NUMBER_FORMAT } from "./constant/common";
import { updateDefaultDateTime } from "@euroland/libs";
import { getCurrenciesNameAction } from "./actions";
import { updateDefault } from "@euroland/format-number";

const initApp = setting => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppWrapper />
      </Provider>
    </React.StrictMode>
  );

  return setting;
};

const publicCompanySettings = settings => {
  const settingsData = settings.data.settings;
  store.dispatch(setSettings(settingsData));
  const { thousandsSeparator, negativeNumberFormat, positiveNumberFormat, decimalSeparator } =
    settingsData.format;
  const useLatinNumber = window.appSettings.isRtl ? settingsData.useLatinNumber : true;
  const formatNumber = convertFormatNumber(settingsData.format);
  // default format number
  updateDefault({
    groupingSeparator: thousandsSeparator,
    decimalSeparator,
    format: formatNumber || FORMAT_NUMBER,
    nagativeFormatPattern: negativeNumberFormat,
    positiveFormatPattern: positiveNumberFormat || POSITIVE_NUMBER_FORMAT,
    useLatinNumbers: useLatinNumber,
  });
  updateDefaultDateTime({
    timeZone: settingsData.timeZone,
    settingFormat: {
      ...settingsData.format,
      fullDate: "DD MMMM YYYY",
      fullDateTime: "DD MMMM YYYY hh:ssA UTC Z",
    },
    useLatinNumbers: useLatinNumber,
  });
  return settings;
};

const loadCustomPharses = settings => {
  if (settings.data.customPhrases) {
    i18n.setCustomPhrases(settings.data.customPhrases.reduce((s, c) => ({ ...s, [c.key]: c.value }), {}));
  }
  return settings;
};

const loadCurrenciesName = settings => {
  let currenciesCode = settings.data.settings.currencies.map(item => item.code);
  // remove duplicate code when setting file xml wrong
  currenciesCode = Array.from(new Set(currenciesCode).values());
  store.dispatch(getCurrenciesNameAction(currenciesCode));
  return settings;
};

function integrate(settings) {
  Promise.all([/*isIFrame(),*/ /*integrationScriptPromise,*/ waitForDocumentReady()])
    .then(() => {
      // Refer to https://gitlab.euroland.com/tools/flipit/integration/-/blob/master/doc/integration-api.md for more detail of implementing integration.
      if (window.euroland && isFunction(window.euroland.integrate)) {
        window.euroland.integrate({
          toolName: window.appSettings.integrationAppName,
          companyCode: window.appSettings.companyCode,
          version: window.appSettings.companyCodeVersion,
          lang: window.appSettings.language,
          allowedParentDomains: settings.data.settings.allowedParentDomains || "*",
        });
      } else {
        throw new Error('Unknown Integration API "window.euroland.integrate".');
      }
    })
    .catch(err => {
      // TODO: just log on dev environment.
      console.warn(`Something wrong occurred with integration script. Stack Traces: ${stringifyError(err)}`);
    });
}

function integrateGoogleAnalytics(settings) {
  const googleAnalyticsEnabled = settings.data.settings.googleAnalyticsEnabled ?? false;
  const googleAnalyticUrl = window.appSettings.googleAnalyticUrl ?? null;
  if (googleAnalyticsEnabled && !!googleAnalyticUrl) {
    let src = document.createElement("script");
    src.src = googleAnalyticUrl;
    (document.head || document.documentElement).appendChild(src);
  }
  return settings;
}

getCompanySettings()
  .then(integrateGoogleAnalytics)
  .then(loadCurrenciesName)
  .then(loadConfiguredCustomStylesheet)
  .then(loadVariableStylesByTemplate)
  .then(publicCompanySettings)
  .then(loadCustomPharses)
  .then(initApp)
  .then(settings => loadSettingEUCalendar({}, settings))
  .then(integrate);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
//registerServiceWorker();
